import { ConfirmationDialogInfo } from './CustomerModel';

export class User {
  sessionId: string;
  displayName: string;
  isAuthenticated!: boolean;
  isImpersonating!: boolean;
  impersonatedCustomer!: string;
  userName!: string;
  constructor(rawItem: any) {
    this.sessionId = rawItem.sessionId;
    this.displayName = rawItem.displayName;
    this.userName = rawItem.displayName;
    this.isAuthenticated = rawItem.isAuthenticated;
    this.isImpersonating = rawItem.isImpersonating;
    this.impersonatedCustomer = rawItem.ImpersonationCustomer;
  }
}
export class AdminUser {
  UserName!: string;
  PublicId!: string;
  DisplayName!: string;
  HasBetaAccess!: boolean;
  IsConfirmed!: boolean;
  LastLoginDate!: string;
  IsEnabled!: boolean;
  HasLoggedIntoBeta!: boolean;
  BetaLoginDate!: string;
  constructor(rawItem: any) {
    this.Populate(rawItem);
  }
  Populate(rawItem: any) {
    if (rawItem) {
      this.UserName = rawItem.UserName;
      this.PublicId = rawItem.PublicId;
      this.DisplayName = rawItem.DisplayName;
      this.HasBetaAccess = rawItem.HasBetaAccess;
      this.IsConfirmed = rawItem.IsConfirmed;
      this.LastLoginDate = rawItem.LastLoginDate;
      this.IsEnabled = rawItem.IsEnabled;
      this.HasLoggedIntoBeta = rawItem.HasLoggedIntoBeta;
    }
  }
}
export class UserValidation {
  isConfirmed!: boolean;
  isAdmin!: boolean;
  constructor(rawItem?: any) {
    if (rawItem) {
      this.isConfirmed = rawItem.isConfirmed;
      this.isAdmin = rawItem.isAdmin;
    } else {
      this.isConfirmed = false;
      this.isAdmin = false;
    }
  }
}
export interface ProfileState {
  user?: User;
  error: boolean;
  storageUser: User;
  userValidation: UserValidation;
  confirmationDialog: ConfirmationDialogInfo;
}
export class CodeRequestInfo {
  CustomerName!: string;
  PO!: string;
  DueDate!: string;
  IsARush!: boolean;
  ShippingDeliveryMethod!: string;
  StatusCode!: string;
  Description!: string;
  PartNumber!: string;
  Sku!: string;
  GTIN!: string;
  ReadableText!: string;
  Asin!: string;
  Quantity!: number;
  Brand!: string;
  BrandId!: string;
  constructor(rawItem?: any) {
    if (rawItem) {
      this.CustomerName = rawItem.CustomerName;
      this.PO = rawItem.PO;
      this.DueDate = rawItem.DueDate;
      this.IsARush = rawItem.IsARush;
      this.ShippingDeliveryMethod = rawItem.ShippingDeliveryMethod;
      this.StatusCode = rawItem.StatusCode;
      this.Description = rawItem.Description;
      this.PartNumber = rawItem.PartNumber;
      this.Sku = rawItem.Sku;
      this.GTIN = rawItem.GTIN;
      this.ReadableText = rawItem.ReadableText;
      this.Asin = rawItem.Asin;
      this.Quantity = rawItem.Quantity;
      this.Brand = rawItem.Brand;
      this.BrandId = rawItem.BrandId;
    }
  }
}
